export default __webpack_public_path__ + "7433fd827821b599c63a0b27fd4e4674.svg";